import styled from 'styled-components'

export const SubHeaderWrapper = styled.div``

export const SubHeaderNavList = styled.ul`
  display: flex;
  gap: 20px;
  padding: 0 40px 0 0px;
  margin: 0 0 20px 0;
  list-style: none;
  border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};
`

export const SubHeaderNavListItem = styled.li`
  padding: 0px;
`

export const SubHeaderNavListLink = styled.div`
  position: relative;
  display: block;
  padding: 12px 0;
  margin: 0 0 -2px 0;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme }) => theme.colors.brand};

    border-bottom: 3px solid ${({ theme }) => theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme }) => theme.colors.primary};
`
